import ExternalPolicyVerification from './ExternalPolicyVerification';

export default ExternalPolicyVerification;
